class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

function normalizeShippingTaxesAccordions(root = document) {
  const canonicalShippingTaxesHtml = `
    <p>We provide worldwide shipping!</p>
    <p>Processing time&nbsp;depends on the product and takes about 1-3 business days.</p>
    <p><strong>Delivery to the USA is free of any customs duties</strong></p>
    <p>We ship via UPS, DHL, and FedEx.</p>
    <p><a href="/pages/shipping" title="Worldwide shipping &amp; taxes">Shipping policy</a></p>
    <hr>
  `;

  root.querySelectorAll('.product__accordion').forEach((accordion) => {
    const heading = accordion.querySelector('.accordion__title');
    if (!heading || heading.textContent.trim() !== 'SHIPPING & TAXES') return;

    const content = accordion.querySelector('.accordion__content');
    if (content) content.innerHTML = canonicalShippingTaxesHtml;
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => normalizeShippingTaxesAccordions());
} else {
  normalizeShippingTaxesAccordions();
}

document.addEventListener('shopify:section:load', (event) => normalizeShippingTaxesAccordions(event.target));
